export const EVENT_BASE_PATH = '/event';
export const EVENT_LIST_PATH = '/list';

export const EVENT_TITLE = 'title.event';
export const EVENT_LIST_TITLE = 'title.event.list';

export const EVENT_LIST_NAMESPACE = 'EVENT-LIST';
